import {action, observable} from 'mobx'
import CatalogSelection from './catalog_selection/CatalogSelection'
import fieldsSettings from './FieldsSettings';

export default class CampaignSettings {
    @observable enabled
    @observable auth_method
    @observable api_key
    @observable auth_token
    @observable id
    @observable yandex_id
    @observable comment_disabled
    @observable yandex_id_in_comment
    @observable use_selected_stock_for_order
    @observable include_hidden_products
    @observable include_unavailable_products
    @observable selected_stock_option
    @observable selected_products_id_option = 'sku_id'
    @observable catalog_selection_mode
    @observable catalog_selection_entities_union
    @observable catalog_stock_ids
    @observable regions
    @observable type
    @observable custom = true
    @observable cis_enabled
    @observable prices_option
    @observable sales_channel
    @observable name
    @observable ya_api_token
    @observable delivery_stock
    @observable order_action_ship
    @observable order_action_pickup
    @observable order_action_complete
    @observable order_action_delete
    @observable order_action_pickup_out
    @observable order_action_accept
    @observable order_action_unpaid
    @observable order_action_processing_prepaid
    @observable order_action_processing_postpaid
    @observable order_action_cancelled
    @observable order_action_cancelled_before
    @observable order_action_cancelled_after
    @observable order_action_cancel_notification
    @observable order_action_delivery
    @observable order_action_delivered
    @observable shipping_id
    @observable payment_id
    @observable shipping_date_in_comment
    @observable cli_command
    @observable cli_command_orders
    @observable price_cli_command
    @observable synchronized_at
    @observable price_synchronized_at
    @observable orders_synchronized_at
    @observable username
    @observable sku_format
    @observable yamarket_stock_id
    @observable contact_id
    @observable order_contact_option
    @observable order_contact_id
    /** @type ConditionsContext */
    @observable condition
    /** @type CatalogSelection */
    @observable catalog_selection
    @observable prices
    @observable add_lift_type
    @observable add_lift_price
    @observable general_prices
    @observable business_id
    @observable sticker_format

    constructor(campaign) {
        if (!campaign.id) {
            return
        }

        this.enabled = campaign.enabled ? campaign.enabled : false
        this.auth_method = campaign.auth_method ? campaign.auth_method : "api_key"
        this.api_key = campaign.api_key ? campaign.api_key : ""
        this.id = campaign.id
        this.yandex_id = campaign.yandex_id ? campaign.yandex_id : ""
        this.comment_disabled = campaign.comment_disabled ? campaign.comment_disabled : false
        this.yandex_id_in_comment = campaign.yandex_id_in_comment ? campaign.yandex_id_in_comment : false
        this.include_hidden_products = campaign.include_hidden_products ? campaign.include_hidden_products : false
        this.include_unavailable_products = campaign.include_unavailable_products ? campaign.include_unavailable_products : false
        this.use_selected_stock_for_order = campaign.use_selected_stock_for_order ? campaign.use_selected_stock_for_order : false
        this.auth_token = campaign.auth_token ? campaign.auth_token : ""
        this.selected_stock_option = campaign.selected_stock_option ? campaign.selected_stock_option : "ALL"
        this.selected_products_id_option = campaign.selected_products_id_option ? campaign.selected_products_id_option : "sku_id"
        this.catalog_stock_ids = campaign.catalog_stock_ids ? campaign.catalog_stock_ids : []
        this.regions = campaign.regions ? campaign.regions : []
        this.type = campaign.type ? campaign.type : "DBS"
        this.custom = campaign.custom !== undefined ? campaign.custom : true
        this.prices_option = campaign.prices_option ? campaign.prices_option : "ymarket"
        this.sales_channel = campaign.sales_channel ? campaign.sales_channel : "Яндекс Маркет"
        this.cis_enabled = campaign.cis_enabled ? campaign.cis_enabled : false
        this.name = campaign.name ? campaign.name : "Новый профиль"
        this.ya_api_token = campaign.ya_api_token ? campaign.ya_api_token : ""
        this.catalog_selection_mode = campaign.catalog_selection_mode
        this.catalog_selection_entities_union = campaign.catalog_selection_entities_union ? campaign.catalog_selection_entities_union : []
        this.catalog_selection = new CatalogSelection(this.catalog_selection_mode, this.catalog_selection_entities_union)
        this.order_action_ship = campaign.order_action_ship
        this.order_action_pickup = campaign.order_action_pickup
        this.order_action_complete = campaign.order_action_complete
        this.order_action_delete = campaign.order_action_delete
        this.order_action_pickup_out = campaign.order_action_pickup_out
        this.order_action_accept = campaign.order_action_accept
        this.order_action_unpaid = campaign.order_action_unpaid
        this.order_action_processing_prepaid = campaign.order_action_processing_prepaid
        this.order_action_processing_postpaid = campaign.order_action_processing_postpaid
        this.order_action_cancelled = campaign.order_action_cancelled
        this.order_action_cancelled_before = campaign.order_action_cancelled_before
        this.order_action_cancelled_after = campaign.order_action_cancelled_after
        this.order_action_cancel_notification = campaign.order_action_cancel_notification
        this.order_action_delivery = campaign.order_action_delivery
        this.order_action_delivered = campaign.order_action_delivered
        this.shipping_id = campaign.shipping_id
        this.payment_id = campaign.payment_id
        this.shipping_date_in_comment = campaign.shipping_date_in_comment
        this.cli_command = campaign.cli_command
        this.cli_command_orders = campaign.cli_command_orders
        this.price_cli_command = campaign.price_cli_command
        this.synchronized_at = campaign.synchronized_at
        this.price_synchronized_at = campaign.price_synchronized_at
        this.orders_synchronized_at = campaign.orders_synchronized_at
        this.username = campaign.username
        this.sku_format = campaign.sku_format
        this.yamarket_stock_id = campaign.yamarket_stock_id
        this.delivery_stock = campaign.delivery_stock
        this.contact_id = campaign.contact_id
        this.order_contact_id = campaign.order_contact_id
        this.order_contact_option = campaign.order_contact_option ? campaign.order_contact_option : 'default'
        fieldsSettings.init(typeof campaign.prices === 'string' ? JSON.parse(campaign.prices) : campaign.prices)
        this.prices = fieldsSettings.fields
        this.add_lift_type = campaign.add_lift_type
        this.add_lift_price = campaign.add_lift_price
        this.business_id = campaign.business_id
        this.general_prices = campaign.general_prices
        this.sticker_format = campaign.sticker_format
    }

    toJSON() {
        return {
            id: this.id,
            enabled: this.enabled,
            auth_method: this.auth_method,
            api_key: this.api_key,
            auth_token: this.auth_token,
            yandex_id: this.yandex_id,
            comment_disabled: this.comment_disabled,
            yandex_id_in_comment: this.yandex_id_in_comment,
            include_hidden_products: this.include_hidden_products,
            include_unavailable_products: this.include_unavailable_products,
            use_selected_stock_for_order: this.use_selected_stock_for_order,
            selected_stock_option: this.selected_stock_option,
            selected_products_id_option: this.selected_products_id_option,
            catalog_stock_ids: this.catalog_stock_ids,
            regions: this.regions,
            type: this.type,
            custom: this.custom,
            prices_option: this.prices_option,
            sales_channel: this.sales_channel,
            cis_enabled: this.cis_enabled,
            add_lift_type: this.add_lift_type,
            add_lift_price: this.add_lift_price,
            name: this.name,
            ya_api_token: this.ya_api_token,
            catalog_selection_mode: this.catalog_selection_mode,
            catalog_selection_entities_union: this.catalog_selection.catalog_selection_entities_union,
            order_action_ship: this.order_action_ship,
            order_action_pickup: this.order_action_pickup,
            order_action_complete: this.order_action_complete,
            order_action_delete: this.order_action_delete,
            order_action_pickup_out: this.order_action_pickup_out,
            order_action_accept: this.order_action_accept,
            order_action_unpaid: this.order_action_unpaid,
            order_action_processing_prepaid: this.order_action_processing_prepaid,
            order_action_processing_postpaid: this.order_action_processing_postpaid,
            order_action_cancelled: this.order_action_cancelled,
            order_action_cancelled_before: this.order_action_cancelled_before,
            order_action_cancelled_after: this.order_action_cancelled_after,
            order_action_cancel_notification: this.order_action_cancel_notification,
            order_action_delivery: this.order_action_delivery,
            order_action_delivered: this.order_action_delivered,
            shipping_id: this.shipping_id,
            payment_id: this.payment_id,
            shipping_date_in_comment: this.shipping_date_in_comment,
            sku_format: this.sku_format,
            yamarket_stock_id: this.yamarket_stock_id,
            username: this.username,
            delivery_stock: this.delivery_stock,
            contact_id: this.contact_id,
            order_contact_id: this.order_contact_id,
            order_contact_option: this.order_contact_option,
            prices: JSON.stringify(this.prices),
            general_prices: this.general_prices,
            business_id: this.business_id,
            sticker_format: this.sticker_format,
        }
    }
}
